export enum ContextEnum {
  "Support_Ticket" = 1,
  "Message" = 2,
}
